import React from "react";
import BalanceMinutesSpentBodyPage from "./BalanceMinutesSpentBodyPage";

const BalanceMinutesSpentBody: React.FC = () => {
    const [page, setPage] = React.useState(0);

    const incrementPage = React.useCallback(() => {
        setPage(page + 1);
    }, [page, setPage]);

    const decrementPage = React.useCallback(() => {
        setPage(Math.max(0, page - 1));
    }, [page, setPage]);

    return (
        <div className="row align-items-start">
            <div className="col">
                <BalanceMinutesSpentBodyPage
                    incrementPage={incrementPage}
                    decrementPage={decrementPage}
                    page={page}
                />
            </div>
        </div>
    );
};

export default BalanceMinutesSpentBody;
